<!-- <button (click)="debug()">Test</button> -->
<div fxLayout="column">
    <div fxLayout="row" fxFlex="1 1 auto">
        <mat-form-field fxFlex="1 1 auto" class="search-bar-chip-list">
            <mat-chip-list #chipList>
                <mat-chip #chip *ngFor="let searchBarTerm of searchBarTerms" (removed)="remove(searchBarTerm)" [selectable]="false" (click)="toggleSelection(searchBarTerm)"
                    [ngClass]="getSearchTermChipClass(searchBarTerm, searchBarTerm.active)" [color]="chipColor(searchBarTerm)">
                    <span *ngIf="!searchBarTerm.option || (searchBarTerm.option.dataType === 'string' || searchBarTerm.option.dataType === 'amount' || searchBarTerm.option.dataType === 'timerange')">{{searchBarTerm.name}}:
                        {{searchBarTerm.value}}
                    </span>
                    <span *ngIf="searchBarTerm.option && searchBarTerm.option.dataType === 'boolean'">{{searchBarTerm.value
                        !=='true' ? '!' : ''}}{{searchBarTerm.name}}</span>
                    <span *ngIf="searchBarTerm.option && searchBarTerm.option.dataType === 'date'">{{searchBarTerm.name}}:
                    </span>
                    <mat-form-field *ngIf="searchBarTerm.option && searchBarTerm.option.dataType === 'date'" class="search-term-date-form-field">
                        <input #searchTermInputDate matInput [matDatepicker]="searchTermDatePicker" [(ngModel)]="searchBarTerm.value">
                        <mat-datepicker-toggle matSuffix [for]="searchTermDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #searchTermDatePicker></mat-datepicker>
                    </mat-form-field>
                    <!-- <div *ngIf="searchBarTerm.option && searchBarTerm.option.dataType === 'timerange'">
                <span>{{searchBarTerm.name}}: </span><p-slider [(ngModel)]="searchBarTerm.valueAny" [range]="true" [min]="0"
                    [max]="10" (onChange)="parseValueAny(searchBarTerm)">Hours Ago</p-slider>
            </div> -->
                    <mat-icon *ngIf="!searchBarTerm.invalid && (!searchBarTerm.option || searchBarTerm.option.dataType !== 'date')" class="search-term-edit-icon"
                        (click)="editSelection(searchBarTerm)" [matTooltip]="'Edit term'" matTooltipPosition="right" [inline]="true">edit</mat-icon>
                    <mat-icon *ngIf="searchBarTerm.invalid" class="search-term-error-icon" (click)="editSelection(searchBarTerm)" [matTooltip]="searchBarTerm.errorMessage"
                        matTooltipPosition="right">error</mat-icon>
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                <input #searchTermInput [placeholder]="placeholder" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="false" (matChipInputTokenEnd)="add($event)" [formControl]="searchTermCtrl" [matAutocomplete]="auto">



                <mat-hint *ngIf="hasErrors">{{ getErrorHint()}}
                </mat-hint>
            </mat-chip-list>

            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="autoCompleteSelected($event)" autoActiveFirstOption>
                <mat-option *ngFor="let value of autoCompleteValues | async" [value]="value">
                    {{value}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <!-- <button mat-icon-button [matMenuTriggerFor]="historyMenu">
            <mat-icon>history</mat-icon>
        </button>
        <mat-menu #historyMenu="matMenu">
            <button mat-menu-item *ngFor="let historicalSearch of historicalSearches" (click)="populateHistoricalSearch(historicalSearch)">
                <span>{{historicalSearch.displayValue}}</span>
            </button>
        </mat-menu> -->
    </div>
    <p-progressBar *ngIf="searching" mode="indeterminate" [style]="{'height': '6px'}" fxFlex="5 5 grow"></p-progressBar>
</div>